import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { industries, IMG } from "../lib/data";
import { Icon } from "../components/Icon";
import PageHero from "../components/PageHero";
import CTASection from "../components/CTASection";

const Industries = () => {
  const { t, lang } = useLanguage();

  return (
    <div data-testid="industries-page">
      <PageHero label={t.industriesPage.label} title={t.industriesPage.heading} sub={t.industriesPage.sub} image={IMG.cityNight} />

      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {industries.map((ind, i) => {
              const d = ind[lang];
              return (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-40px" }}
                  transition={{ duration: 0.45, delay: (i % 3) * 0.08 }}
                  className="group relative bg-[#11203A] border border-white/12 p-8 hover:bg-[#1A2C47] hover:-translate-y-1 transition-all duration-300"
                  data-testid={`industry-card-${i}`}
                >
                  <div className="flex items-start justify-between">
                    <div className="w-12 h-12 grid place-items-center border border-[#D4AF37]/30 text-[#D4AF37] group-hover:bg-[#D4AF37] group-hover:text-[#0A1223] transition-colors duration-300">
                      <Icon name={ind.icon} size={22} />
                    </div>
                    <ArrowUpRight size={20} className="text-slate-600 group-hover:text-[#D4AF37] transition-colors" />
                  </div>
                  <h3 className="font-heading text-xl font-bold text-white mt-6">{d.title}</h3>
                  <p className="mt-3 text-sm text-slate-300 leading-relaxed">{d.desc}</p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>
      <CTASection />
    </div>
  );
};

export default Industries;
